module.exports = __webpack_public_path__ + "img/wancheng.58120d8c.svg";